import { render, staticRenderFns } from "./addPropertyRightRegistration.vue?vue&type=template&id=de9b4c6a&scoped=true"
import script from "./addPropertyRightRegistration.vue?vue&type=script&lang=js"
export * from "./addPropertyRightRegistration.vue?vue&type=script&lang=js"
import style0 from "./addPropertyRightRegistration.vue?vue&type=style&index=0&id=de9b4c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9b4c6a",
  null
  
)

export default component.exports